import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorModalComponent } from 'src/app/common/error-modal/error-modal.component';
import { EncryptionService } from 'src/app/services/encryption.service';
import { AppService } from 'src/app/services/services';

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss']
})
export class SignatureComponent {
@ViewChild('foAdrimg') foAdrimgError: ElementRef;
  foAdrUpdt:boolean = false;
  foImgempty: boolean;
  foType: any;
  docError: boolean = false;
  erefNo: string = '';
  @ViewChild('errorComp') errorComp: ErrorModalComponent;
constructor(public _http: AppService, private http: EncryptionService, private router: Router, private toastr: ToastrService, private loader: NgxUiLoaderService) {
        this._http.getRefNum().subscribe(data => {
            this.erefNo = data;
        });
       

        
    }

  imageURL(event: any){
      if(event.url && event.name === "signature"){
        this.foAdrUpdt = true;
        this.foImgempty = false;
      }
    }
    getID(id: any) {
        this.foType = id;
    }
     typeError(event: boolean) {
        this.docError = event;
    }
     backStage() {
        this.router.navigate(['/segments'], { replaceUrl: true })
    }
    stageValidate() {
        let error = 0;
        if(!this.foAdrUpdt){
            this.docError = true;
            error ++;
            this.errorComp.ModalShow('Please upload your Signature image');
            return;
        }else{
          this.router.navigate(['/terms'], { replaceUrl: true });
        }
}
}
